import { render, staticRenderFns } from "./FletrixPhone.vue?vue&type=template&id=725a19a0&scoped=true&"
import script from "./FletrixPhone.vue?vue&type=script&lang=js&"
export * from "./FletrixPhone.vue?vue&type=script&lang=js&"
import style0 from "./FletrixPhone.vue?vue&type=style&index=0&id=725a19a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725a19a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VTextField})
